import { useCallback } from 'react'
import type { AnalyticsEventProperties } from 'core/analytics/analytics-types'
import type { TrajectoryEvent } from 'core/constants/trajectory-analytics'
import { trackTrajectoryEvent } from './track-trajectory-event'

export const useTrajectoryAnalytics = () => {
  return useCallback((event: TrajectoryEvent, properties?: AnalyticsEventProperties) => {
    trackTrajectoryEvent(event, properties)
  }, [])
}
